<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.01497 35V32.0455H23.5983V35H27.9733V26.1364L26.515 23.1818H29.4316V21.7045H25.0566L22.14 18.75H10.4733L7.55664 21.7045H3.18164V23.1818H6.09831L4.63997 26.1364V35H9.01497ZM25.0566 24.6591L22.14 20.2273H10.4733L7.55664 24.6591H25.0566ZM9.01497 26.1364L10.4733 29.0909H6.09831V26.1364H9.01497ZM26.515 29.0909H22.14L23.5983 26.1364H26.515V29.0909ZM14.8483 26.1364V29.0909H17.765V26.1364H22.14L19.9525 30.5682H12.6608L10.4733 26.1364H14.8483Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.515 15V13.4091H19.8483V15H20.6816L21.515 13.75L22.3483 12.6136V10.2273L21.515 8.63636H23.1816V7.84091H20.6816L19.015 6.25H12.3483L10.6816 7.84091H8.18164V8.63636H9.84831L9.01497 10.2273V15H11.515ZM20.6816 9.43182L19.015 7.04545H12.3483L10.6816 9.43182H20.6816ZM11.515 10.2273L12.3483 11.8182H9.84831V10.2273H11.515ZM21.515 11.8182H19.015L19.8483 10.2273H21.515V11.8182ZM14.8483 10.2273V11.8182H16.515V10.2273H19.015L17.765 12.6136H13.5983L12.3483 10.2273H14.8483Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.3483 20.2273H32.765V22.5H35.89V15.6818L34.8483 13.4091H36.9316V12.2727H33.8066L31.7233 10H23.39L21.3066 12.2727H18.1816V13.4091H20.265L19.2233 15.6818L19.4316 20L22.3483 20.2273ZM33.8066 14.5455L31.7233 11.1364H23.39L21.3066 14.5455H33.8066ZM22.3483 15.6818L23.39 17.9545H20.265V15.6818H22.3483ZM34.8483 17.9545H31.7233L32.765 15.6818H34.8483V17.9545ZM26.515 15.6818V17.9545H28.5983V15.6818H31.7233L30.1608 19.0909H24.9525L23.39 15.6818H26.515Z"
      class="fill-current"
    />
  </svg>
</template>
